// @flow
import * as React from 'react';
import ReactFlow, {
  Background,
  Controls,
  ControlButton,
} from 'react-flow-renderer';
import classNames from 'classnames';

import Icon from 'sail/Icon';
import * as Assets from 'sail/Icon/Assets';
import ModalLayer from 'sail/ModalLayer';
import Box from 'sail/Box';
import Group from 'sail/Group';

import {CodeBlock} from 'docs/components';
import './DiagramGenerator.scss';
import {useDiagramGenerator} from 'docs/data';
import {AddNode} from './components/AddNode';
import {AddEdge} from './components/AddEdge';
import {nodeTypes} from '../nodeTypes';
import {DiagramSelector} from './components/DiagramSelector';

const AddNodeDialog = () => {
  const {showNodeModal, setShowNodeModal} = useDiagramGenerator();
  return (
    <ModalLayer
      shown={!!showNodeModal}
      onWashClick={() => {
        setShowNodeModal(false);
      }}
      onEscape={() => {
        setShowNodeModal(false);
      }}
    >
      <AddNode />
    </ModalLayer>
  );
};

const AddEdgeDialog = () => {
  const {showEdgeModal, setShowEdgeModal} = useDiagramGenerator();
  return (
    <ModalLayer
      shown={!!showEdgeModal}
      onWashClick={() => {
        setShowEdgeModal(false);
      }}
      onEscape={() => {
        setShowEdgeModal(false);
      }}
    >
      <AddEdge />
    </ModalLayer>
  );
};

const MarkdocCodeBlock = () => {
  const {markdoc} = useDiagramGenerator();
  return (
    <CodeBlock filename="diagram.md" language="markdoc">
      {markdoc}
    </CodeBlock>
  );
};

export const DiagramGeneratorContent = () => {
  // State required to render the diagram
  const {
    elements,
    showHandles,
    addEdge,
    onNodeDragStop,
    setShowNodeModal,
  } = useDiagramGenerator();

  return (
    <Group spacing={16}>
      <DiagramSelector />
      <Box>
        <Group>
          <Box
            className={classNames(
              'Diagram',
              'DiagramGenerator',
              !showHandles && 'hideHandles',
            )}
            margin={{top: 12}}
          >
            <ReactFlow
              elements={elements}
              nodeTypes={nodeTypes}
              onLoad={(reactFlowInstance) => {
                reactFlowInstance.fitView();
              }}
              nodesConnectable
              nodesDraggable
              onConnect={addEdge}
              connectionMode="loose"
              onNodeDragStop={onNodeDragStop}
            >
              <Background variant="dots" gap={16} size={1} color="#C0C8D2" />
              <Controls>
                <ControlButton onClick={() => setShowNodeModal(true)}>
                  <Icon icon={Assets.addCircle} color="purple" />
                </ControlButton>
              </Controls>
            </ReactFlow>
            <AddNodeDialog />
            <AddEdgeDialog />
          </Box>
        </Group>
        <MarkdocCodeBlock />
      </Box>
    </Group>
  );
};
